import { Form } from 'factorial-form'
import { computed, makeObservable } from 'mobx'
import moment from 'moment'

import i18n from 'modules/core/lib/i18n'

const TIME_REGEX = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/

class ShiftForm extends Form {
  constructor(values = {}) {
    super(
      { ...values },
      {
        name: 'string',
        start_time: 'string',
        end_time: 'string',
        extra_hours: 'boolean',
        notes: 'string',
        location_id: 'string',
        work_area_id: 'string',
      }
    )
    makeObservable(this, {
      startAt: computed,
      endAt: computed,
      isValidStartAt: computed,
      isValidEndAt: computed,
    })
  }

  get startAt() {
    return moment(this.get('start_time').value, 'HH:mm')
  }

  get endAt() {
    return moment(this.get('end_time').value, 'HH:mm')
  }

  get isValidStartAt(): boolean {
    const value = this.get('start_time').value
    return value.length > 0 && TIME_REGEX.test(value)
  }

  get isValidEndAt(): boolean {
    const value = this.get('end_time').value
    return value.length > 0 && TIME_REGEX.test(value)
  }

  get isValid(): boolean {
    return this.isDirty && this.isValidStartAt && this.isValidEndAt
  }

  validate(): boolean {
    this.resetErrors()

    if (!this.isValidStartAt) {
      this.get('start_time').setErrors([
        i18n.t('shift_management.actions_sidepanel.errors.no_time_frame'),
      ])
    }

    if (!this.isValidEndAt) {
      this.get('end_time').setErrors([
        i18n.t('shift_management.actions_sidepanel.errors.no_time_frame'),
      ])
    }

    return !this.hasErrors
  }
}

export default ShiftForm
